/* Fast Object.assign for webOS 3 (Chromium 38).

   core-js's `es.object.assign` shim (installed by the legacy polyfills bundle
   because Chrome 38 lacks native Object.assign) is ~20x slower than a plain
   for-in copy: every call goes through core-js's uncurryThis/call/defineProperty
   machinery, and the spatial-nav HOC chain + Babel object-spread helpers call
   Object.assign on every focusable render. Measured on the TV (Chromium 38):
   6432ms vs 308ms for 2000 copies of a 30-key object.

   Installs a minimal spec-correct-enough Object.assign for the app's usage
   (plain objects, own enumerable string keys; symbol keys unused by the app)
   and runs before any app code spreads objects. Imported from src/index.jsx
   BEFORE the provider imports.

   NOTE: the same install ALSO runs as an inline <script> in index.html (search
   "Fast Object.assign for webOS 3") so Object.assign exists before the legacy
   vendor chunk evaluates — vendor calls Object.assign at module-eval time
   (React 17 PureComponent prototype setup) and the legacy polyfills no longer
   install es.object.assign. Keep the two in sync. Both guards leave a NATIVE
   Object.assign (modern browsers) untouched. */

// eslint-disable-next-line no-underscore-dangle -- marker property, mirrors findDOMNodeCompat
const fastAssignInstalled = typeof Object.assign === 'function' && !!Object.assign.__dtvFastAssign;
const isNativeAssign = typeof Object.assign === 'function'
  // eslint-disable-next-line unicorn/prefer-includes -- indexOf is ES5; no includes on Chrome 38
  && String(Object.assign).indexOf('[native code]') !== -1;
if (!isNativeAssign && !fastAssignInstalled) {
  const fastAssign = function fastAssign(target, ...sources) {
    if (target === undefined || target === null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }
    // eslint-disable-next-line no-new-object -- new Object() coerces primitives per spec
    const to = new Object(target);
    for (const nextSource of sources) {
      if (nextSource === undefined || nextSource === null) continue;
      // eslint-disable-next-line no-new-object -- new Object() coerces primitives per spec
      const from = new Object(nextSource);
      // eslint-disable-next-line no-restricted-syntax, guard-for-in -- plain for-in copy
      for (const nextKey in from) {
        if (Object.prototype.hasOwnProperty.call(from, nextKey)) {
          to[nextKey] = from[nextKey];
        }
      }
    }
    return to;
  };
  // eslint-disable-next-line no-underscore-dangle -- marker property, mirrors findDOMNodeCompat
  fastAssign.__dtvFastAssign = true;
  Object.assign = fastAssign;
}
